import { ServiceHistory } from '@services';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useAllServiceHistories = (
  vin?: string,
  statuses?: string
): { serviceHistories: ServiceHistory[]; loading: boolean } => {
  const { serviceHistoryStore } = useStore();
  const { serviceHistories, loading } = serviceHistoryStore;

  useEffect(() => {
    return () => {
      serviceHistoryStore.resetServiceHistories();
    };
  }, [serviceHistoryStore]);

  useEffect(() => {
    vin &&
      serviceHistoryStore.getAll({
        vin,
        maxResultCount: 100,
        skipCount: 0,
        statuses: statuses || undefined,
      });
  }, [serviceHistoryStore, vin, statuses]);

  return {
    loading,
    serviceHistories: Array.from(serviceHistories.values()),
  };
};
